<template>
  <header class="main-header">
    <div class="container">
      <nav class="navbar rounded-navbar">
        <!-- Mobile Menu Button -->
        <div class="logo">
          <img :src="logoSrc" alt="شعار الموقع">
        </div>
        <div class="mobile-menu-btn" @click="toggleMenu" :class="{ 'active': isSideMenuOpen }">
          <div class="bar"></div>
          <div class="bar"></div>
          <div class="bar"></div>
        </div>



        <!-- Desktop Navigation -->
        <ul class="nav-links">
          <li>
            <router-link to="/" :class="{ 'active-link': $route.path === '/' || $route.path === '/home' }">الرئيسية</router-link>
          </li>
          <li>
            <router-link to="/courses" exact-active-class="active-link">الكورسات</router-link>
          </li>
          <li>
            <router-link to="/exams" exact-active-class="active-link">الامتحانات</router-link>
          </li>
          <li>
            <router-link to="/homework" exact-active-class="active-link">الواجبات</router-link>
          </li>
          <!-- <li>
            <router-link to="/notes" exact-active-class="active-link">المذكرات</router-link>
          </li> -->
        </ul>

        <div class="user-actions">
          <img v-if="isLoggedIn" :src="profileImgSrc" alt="Profile" class="profile-img" @click="goToProfilePage" />
        <button v-else class="login-btn" @click="goToLoginPage">ابدأ معنا</button>
        </div>

        <!-- Mobile Menu -->
        <div class="mobile-menu" :class="{ 'active': isSideMenuOpen }">
          <!-- <div class="close-btn" @click="closeMenu">
            <span class="close-icon">×</span>
          </div> -->
          <router-link to="/" @click="closeMenu">الرئيسية</router-link>
          <router-link to="/courses" @click="closeMenu">الكورسات</router-link>
          <router-link to="/exams" @click="closeMenu">الامتحانات</router-link>
          <router-link to="/homework" @click="closeMenu">الواجبات</router-link>
          <!-- <router-link to="/notes" @click="closeMenu">المذكرات</router-link> -->
          <img v-if="isLoggedIn" :src="profileImgSrc" alt="Profile" class="profile-img" @click="goToProfilePage" />
          <button class="mobile-login-btn" @click="goToLoginPage">إبدأ معنا</button>
        </div>
      </nav>
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'Navbar',
  data() {
    return {
      logoSrc: require('@/assets/images/main-logo.svg'),
      profileImgSrc: require('@/assets/images/profile.png'),
      isSideMenuOpen: false
    };
  },
  computed: {
    ...mapGetters(['isLoggedIn']),
  },
  methods: {
    toggleMenu() {
      this.isSideMenuOpen = !this.isSideMenuOpen;
    },
    closeMenu() {
      this.isSideMenuOpen = false;
    },
    goToLoginPage() {
      this.$router.push({ name: 'Login' });
    },
    goToProfilePage() {
      this.$router.push({ name: 'Profile' });
    },
  }
}
</script>

<style>
.main-header {
  position: fixed;
  width: 100%;
  padding: 20px 0;
  z-index: 1000;
  background-color: transparent;
  transition: background-color 0.3s;
}

.container {
  width: 90%;
  max-width: 1700px;
  margin: 0 auto;
}

.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 30px !important;
  background-color: #fff;
  position: relative;
}

.rounded-navbar {
  border-radius: 50px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.logo img {
  height: 50px;
  width: 100%;
  width: auto;
}

/* Desktop Navigation */
.nav-links {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}

.nav-links li {
  margin: 0 15px;
  position: relative;
}

.nav-links a {
  color: #000;
  text-decoration: none;
  font-size: 18px;
  transition: color 0.3s;
  padding: 8px 12px;
  font-weight: 500;
  display: block;
}

.active-link {
  color: #FF9A18 !important;
  position: relative;
}

/* .active-link::after {
  content: "";
  position: absolute;
  bottom: -5px;
  right: 0;
  width: 100%;
  height: 2px;
  background-color: #FF9A18;
} */

.nav-links a:hover {
  color: #FF9A18;
}

.nav-links li::after {
  content: "";
  position: absolute;
  bottom: -5px;
  right: 0;
  width: 0;
  height: 2px;
  background-color: #FF9A18;
  transition: width 0.3s;
}

.nav-links li:hover::after {
  width: 100%;
}

/* User Actions */
.user-actions {
  display: flex;
  align-items: center;
  gap: 20px;
}

.login-btn {
  background-color: #FF9A18;
  color: white;
  border: none;
  padding: 10px 25px;
  border-radius: 30px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s;
  font-weight: 500;
}

.login-btn:hover {
  background-color: #e67e22;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
.profile-img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
}
/* Mobile Menu Button (Hidden by default) */
.mobile-menu-btn {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 30px;
  height: 21px;
  cursor: pointer;
  z-index: 1001;
}

.mobile-menu-btn .bar {
  height: 3px;
  width: 100%;
  background-color: #333;
  border-radius: 10px;
  transition: all 0.3s ease;
}

/* Mobile Menu (Hidden by default) */
.mobile-menu {
  display: none;
  position: fixed;
  top: 0;
  left: -100%;
  width: 70%;
  height: 100vh;
  background-color: #fff;
  box-shadow: -5px 0 15px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  transition: right 0.3s ease;
  padding: 80px 20px 20px;
  flex-direction: column;
  gap: 15px;
}

.mobile-menu.active {
  left: 0;
}

.mobile-menu a {
  color: #333;
  text-decoration: none;
  font-size: 18px;
  text-align: right;
  font-weight: 500;
  padding: 12px;
  border-bottom: 1px solid #eee;
  transition: all 0.3s;
}

.mobile-menu a:hover,
.mobile-menu a.router-link-active {
  color: #FF9A18;
  padding-right: 20px;
}

.mobile-login-btn {
  background-color: #FF9A18;
  color: white;
  border: none;
  padding: 12px;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  margin-top: 20px;
  text-align: center;
    font-weight: 500;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .nav-links li {
    margin: 0 10px;
  }
  
  .nav-links a {
    font-size: 16px;
  }
  
  .login-btn {
    padding: 8px 20px;
    font-size: 14px;
  }
}

@media (max-width: 992px) {
  .mobile-menu-btn {
    display: flex;
  }
  
  .nav-links,
  .user-actions {
    display: none;
  }
  
  /* .logo {
    margin-right: auto;
    margin-left: 20px;
  } */
  
  .navbar {
    padding: 15px 20px !important;
  }
  
  .mobile-menu {
    display: flex;
  }
}

@media (max-width: 576px) {
  .container {
    width: 95%;
  }
  
  .logo img {
    height: 40px;
  }
  
  .mobile-menu {
    width: 80%;
  }
  
  .main-header {
    padding: 15px 0;
  }
}
.close-btn {
  position: absolute;
  top: 20px;
  left: 20px;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1002;
}

.close-icon {
  font-size: 30px;
  color: #333;
  line-height: 1;
  transition: all 0.3s;
}

.close-btn:hover .close-icon {
  color: #FF9A18;
  transform: scale(1.2);
}

/* Animation for mobile menu button when active */
.mobile-menu-btn.active .bar:nth-child(1) {
  transform: translateY(9px) rotate(45deg);
}

.mobile-menu-btn.active .bar:nth-child(2) {
  opacity: 0;
}

.mobile-menu-btn.active .bar:nth-child(3) {
  transform: translateY(-9px) rotate(-45deg);
}
</style>